import { TSobReportSalesType } from 'legacy/lut/components/widgets/public/partner360/configs/reports'

import { ISobAnalyticsReportJoined } from 'partner360/models/report/sobAnalyticsReports/ISobAnalyticsReportJoined'

import { calculateTam } from '../../calculateTam'
import { calculateWeightedAverageSob } from '../../calculateWightedAverageSob'
import { getPlainAverageSob } from '../../getPlainAverageSob'

import { calculateEstimatedRevenueForPeriod } from './calculateEstimatedRevenueForPeriod'
import {
  calculateDisplayRevenueForPeriod,
  calculateRevenueForPeriod,
} from './calculateRevenueForPeriod'

interface IParams {
  data: ISobAnalyticsReportJoined[]
  quarters: number[]
  netNdp: TSobReportSalesType
  isFuture?: boolean
  // Expected Exit (ExpExitCYQ{q}{netNdp}, SobExpExitQ{q}); takes precedence over isFuture
  isExpectedExit?: boolean
}

export const calculateSobAnalyticsForPeriod = ({
  data,
  quarters,
  netNdp,
  isFuture = false,
  isExpectedExit = false,
}: IParams) => {
  const revenueField = isExpectedExit ? 'ExpExit' : isFuture ? 'Plans' : 'Actuals'
  const sobField = isExpectedExit ? 'ExpExit' : isFuture ? 'Plan' : 'Actual'

  // This calculations made for ability to diplay revenue for cases when sob doesn't exists
  const displayActualsRevenue = calculateDisplayRevenueForPeriod({
    data,
    quarters,
    netNdp,
    revenueField,
  })

  // sumActuals
  const actualsRevenue = calculateRevenueForPeriod({
    data,
    quarters,
    revenueField,
    sobField,
    netNdp,
  })

  // sumActualsToSob
  const estimatedActualsRevenue = calculateEstimatedRevenueForPeriod({
    data,
    quarters,
    sobField,
    revenueField,
    netNdp,
  })

  const sob = calculateWeightedAverageSob({
    revenue: actualsRevenue,
    estimatedRevenue: estimatedActualsRevenue,
  })

  const tam = calculateTam({
    actuals: actualsRevenue,
    sobActuals: sob,
  })

  const plainSob = getPlainAverageSob({
    data,
    quarters,
    isFuture,
    isExpectedExit,
  })

  return {
    actualsRevenue: displayActualsRevenue,
    estimatedActualsRevenue,
    sob,
    plainSob,
    tam,
  }
}
